import { MarketBasedData } from 'models/ActivityDataEntryScopes/marketBased.model';
import { ScopeData } from 'models/ActivityDataEntryScopes/scopes.model';

export const replaceUndefinedWithNull = (
  obj: MarketBasedData
): MarketBasedData | null => {
  if (obj && typeof obj === 'object') {
    let allUndefined = true;

    // Loop through each key in the object
    (Object.keys(obj) as Array<keyof MarketBasedData>).forEach(key => {
      if (obj[key] === undefined) {
        obj[key] = null;
      } else {
        allUndefined = false; // If any key is not undefined, mark allUndefined as false
      }
    });

    // If all properties were undefined, return null instead of the modified object
    return allUndefined ? null : obj;
  }

  return obj;
};

// Helper function to convert each item
export const transformItem = (item: ScopeData) => ({
  ...item,
   // Un comment after client give confirmation
  // electricityFromRec:
  //   item?.electricityFromRec &&
  //   (item.fuelValue || item.fuelValue == 0
  //     ? replaceUndefinedWithNull(item?.electricityFromRec)
  //     : null),
});
